export default {
      id: "small-star-outline-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-star-outline",
      toString: function () {
        return this.url;
      }
    }